$.fn.scrollToAnchor = function() {
  let self = this

  self.click(function() {
    hash = $(this).attr('href');
    targetTop = $(hash).offset().top;
    targetTop -= $('.header').outerHeight(false) + ($.mlmi.mobile.isMobile ? 18 : 24)
    $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
    return false;
  });

  return function() {
    return self
  }()
};
